module.exports = __webpack_public_path__ + "img/TransformerMeasurement.31e9b570.svg";